import { TourSteps } from './interface/tour-steps.interface';
import Step from 'shepherd.js/src/types/step';

export const assignMealPlanSelectStep: (tourSteps: TourSteps) => Step.StepOptions[] = ({steps, buttons}: TourSteps): Step.StepOptions[] => {
  return [
    {
      ...steps.default,
      id: 'registerMealPlanStep1',
      title: 'Buscar plan de alimentación',
      text: `Para asignar un plan de alimentación podemos hacer la búsqueda mediante el siguiente campo. Para fines del tour, se ha creado un plan de alimentación de prueba`,
      attachTo: {
        element: '.shepherd-input-search-meal-plan',
        on: 'bottom'
      },
      canClickTarget: false,
    },
    {
      ...steps.default,
      id: 'registerMealPlanStep1',
      title: 'Filtrar planes de alimentación',
      text: `Si deseamos buscar planes de alimentación más específicos, podemos filtrar por las categorías.`,
      attachTo: {
        element: '.shepherd-select-category-filter',
        on: 'bottom'
      },
      canClickTarget: false,
    },
    {
      ...steps.default,
      id: 'registerMealPlanStep1',
      title: 'Plan de alimentación',
      text: `El sistema ha creado un plan de alimentación, el cual usaremos para continuar con el tour.`,
      attachTo: {
        element: '.shepherd-meal-plan-demo',
        on: 'bottom'
      },
      canClickTarget: false,
    },
    {
      ...steps.default,
      id: 'registerMealPlanStep12312123',
      title: 'Seleccionar plan de alimentación',
      text: `Una vez que hayas identificado el plan de alimentación que deseas asignar al paciente, tendrás que presionar sobre el botón para ver más detalles del mismo.`,
      attachTo: {
        element: '.shepherd-meal-plan-demo .shepherd-button-select',
        on: 'bottom'
      },
      advanceOn: {
        selector: '.shepherd-meal-plan-demo .shepherd-button-select',
        event: 'click',
      },
      buttons: [{ ...buttons.cancel }],
    },
  ];
};
